hba = (($)->

#  devMode = true
  devMode = false

  jM = undefined # jQuery map
  timer = undefined
  isFading = false

  active_project = 'start'

  slideshow_speed = 10000

  if devMode
    fade_duration = 10
  else
    fade_duration = 1000

  hbaProjekte = undefined
  currProjekt = 'start'

  # jQuery DOM objects map
  setJQueryMap = ->
    jM = {
      body: $ 'body'
      projectLink: $ 'header a, .project-link'
      right: $('#right')
      left: $('#left')
      pages: $ '.page'
      pInfoContent: $ '#projekt_info .text'
      btm_overlay: $ '.btm-overlay'
      btm_toggle: $ '.btm-toggle'
      mail: $ '.mail'
    }


  # region DOM methods

  encodeEmails = ->
    jM.mail.each ->
      $this = $(this)
      target = 'post'
      link = target + '@helgablocksdorf.de'
      text = $this.text() || link
      $mailto_link = $('<a/>').attr(href: 'mailto:' + link).text(text)
      $this.html $mailto_link


  slideshow = ->
    jM.right.trigger 'click'
    timer = setTimeout((->
      slideshow()
    ), slideshow_speed)

  renderProjektInfo = (projekt) ->
    console.log('projekt: ', projekt)

    if (projekt != 'start' and hbaProjekte)
      projektData = hbaProjekte[projekt]
      console.log 'this projekt data: ', projektData
      jM.pInfoContent.html ''
      $.each projektData.content, ->

        if this.label or this.text
          p = $('<p/>')
          if this.label then p.append $('<span class="fett" />').text(this.label)
          if this.text then p.append $('<span />').html(' '+this.text)
          jM.pInfoContent.append p
        else
          jM.pInfoContent.append $('<p/>').html(this)

  preloadNextPage = ->
    $active_page = $('.page.active')
    if $active_page.is(':last-child')
      $next_page = $('.page:first-child')
    else
      $next_page = $active_page.next()
    $next_page.show();

  preloadPrevPage = ->
    $active_page = $('.page.active')
    if $active_page.is(':first-child')
      $prev_page = $('.page:last-child')
    else
      $prev_page = $active_page.prev()
    $prev_page.show();

  navigate = (direction, page_id) ->
    if !isFading
      isFading = true
      setTimeout((->
        isFading = false
      ), fade_duration )

      $active_page = $('.page.active')
      active_page_id = $active_page.attr('id')
      $next_page = undefined
      if page_id
        $next_page = $('#'+page_id).show()
      else
        if $active_page.is(':last-child') and direction == 'next'
          $next_page = $('.page:first-child')

        else if active_page_id == 'page_start' and direction == 'prev'
          $next_page = $('.page:last-child')

        else
          $next_page = if direction == 'prev' then $active_page.prev() else $active_page.next()

  #    console.log '$next_page: ', $next_page
      this_project = $next_page.data 'project'
  #    console.log 'project: ', this_project

      if this_project != currProjekt
        renderProjektInfo this_project
        jM.projectLink.removeClass('active').filter('[data-project='+this_project+']').addClass 'active'
        currProjekt = this_project


      $('.show').removeClass 'show'

      clearTimeout timer
  #    $('.navi').unbind 'click'
      $active_page.removeClass 'active'


      if $next_page.attr('id') != 'page_start'
        jM.btm_overlay.fadeIn fade_duration
#  #      jM.body.removeClass 'start'
      else
        jM.btm_overlay.fadeOut fade_duration
#  #      jM.body.addClass 'start'


#      $active_page.fadeOut fade_duration


      if page_id

        setTimeout((->
          $next_page.addClass 'active'
          preloadNextPage()
          preloadPrevPage()
        ), 100)

      else
        $next_page.addClass 'active'
        if direction == 'prev'
          preloadPrevPage()
        else
          preloadNextPage()


    #      $next_page.fadeIn fade_duration, ->
#        $(this).addClass 'active'
  #      jM.right.on 'click', (event) ->
  #        navigate 'next'
  #        false
  #
  #      jM.left.on 'click', (event) ->
  #        navigate 'prev'
  #        false

    false

  # endregion DOM methods

  init = ->

    setJQueryMap()

    encodeEmails()

    $.getJSON '/assets/js/hba_projekte.json?v=230511', (data) ->
      hbaProjekte = data
#      console.log 'data: ', hbaProjekte

    preloadNextPage()
    preloadPrevPage()

#    if !devMode
#      timer = setTimeout((->
#        slideshow()
#      ), slideshow_speed)

    jM.right.on 'click', ->
      console.log('click right')
      navigate 'next'
      false

    jM.left.on 'click', ->
      console.log('click left')
      navigate 'prev'
      false

    jM.projectLink.on 'click', (e) ->
      e.preventDefault()
      $this = $(this)
      if !isFading
        project_id = $this.data 'target-id'
        navigate(undefined, project_id)
      false


    jM.btm_toggle.on 'click', ->
      $thisOverlay = $(this).closest '.btm-overlay'
      if $thisOverlay.hasClass 'show'
        $thisOverlay.removeClass 'show'
      else
        jM.btm_overlay.removeClass 'show'
        $thisOverlay.addClass 'show'

    jM.body.on 'keyup', (e) ->

#        left = 37
#        up = 38
#        right = 39
#        down = 40
      if e.keyCode == 37
        jM.left.trigger 'click'
      else if e.keyCode == 39
        jM.right.trigger 'click'


  { init: init }

)(jQuery)

jQuery ->
  hba.init()